import { createContext, useContext } from "react";

/**
 * Context for validation errors.
 * Separated from ColumnContext to prevent column rebuilds when validation errors change.
 * Cells subscribe to this context independently, so only cells with errors re-render.
 */
export const ValidationErrorsContext = createContext<Record<string, string | undefined>>({});

/**
 * Hook to access validation errors from context.
 * Use this in Cell components instead of context.validationErrors
 */
export function useValidationErrors(): Record<string, string | undefined> {
	return useContext(ValidationErrorsContext);
}
